<button (click)="close()">x</button>
<ol class="log-container">
  <li *ngFor="let log of logs">{{ log.message }} {{ log.additional?.toString() }}</li>
</ol>
